import { render, staticRenderFns } from "./ChioseDialog.vue?vue&type=template&id=fb68ff9e&scoped=true&"
import script from "./ChioseDialog.vue?vue&type=script&lang=js&"
export * from "./ChioseDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChioseDialog.vue?vue&type=style&index=0&id=fb68ff9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb68ff9e",
  null
  
)

export default component.exports